class Name {
  constructor() {
  	this.sex = ''
    this.firstName = ''
    this.lastName = ''
  }
}
export { Name }
